/*
 * @Author: your name
 * @Date: 2021-01-18 17:58:31
 * @LastEditTime: 2021-08-13 14:09:35
 * @LastEditors: yang chenglin
 * @Description: 店铺概况
 * @FilePath: \CJYX_DouYin\src\pages\Home\DY_components\DYShopSurvey\index.tsx
 */
import React, { useEffect, useState } from 'react';
import { Chart, LineAdvance, Tooltip } from 'bizcharts';
import { Balloon, Tag } from '@alifd/next';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import ParagraphTitle from '../../components/ParagraphTitle';
import moment from 'moment';
import TimeTab from '../../components/TimeTab';

// 日期tab
const trendList = [{
  tab: '昨日',
  key: 1,
},
{
  tab: '近7天',
  key: 7,
},
{
  tab: '近30天',
  key: 30,
}];
// 标签解释
// tag标签标题数据  通过 接口数据的
// 分析id (analysisId): 1-支付用户总数 2-支付总金额（元） 3-客单价（元） 4-新客用户数 5-新客支付金额（元） 6-新客客单价（元）
const tagExplain = ['店铺首次购买客户', '店铺首次购买金额', '店铺首次购买总金额/店铺首次购买用户数'];
const chartTitle = ['支付用户总数', '支付总金额（元）', '客单价（元）', '新客用户数', '新客支付金额（元）', '新客客单价（元）'];
const DYShopSurvey = () => {
  const { Tooltip } = Balloon;
  // 选择的日期tab
  const [currentKey, setCurrentKey] = useState(1);
  // z折线图数据
  const [lineChartData, setLineChartData] = useState([]);
  // 选中的tag标签
  const [chooseTag, setChooseTag] = useState(1);
  // 选中的展示的折线图
  const [chooseLinechartData, setChooseLinechartData] = useState([]);
  // 标签tag
  const [tagList, setTagList] = useState({
    newCustomerPrice: 0,
    newPayAmount: 0,
    newPayUsers: 0,
    oldCustomerPrice: 0,
    oldPayAmount: 0,
    oldPayUsers: 0,
  });
  // 是否需要 scale 即：固定y轴范围
  const [yAxisNeed, setYAxisNeed] = useState();


  // 标签 选中状态
  const [tagChooseStatu, setTagChooseStatu] = useState([true, false, false, false, false, false]);
  // 折线图数据
  const data = [
    { time: '12-20', total: 1000, title: '支付用户总数', type1: 1 },
    { time: '12-20', total: 2000, title: '支付总金额（元）', type: 2 },
    { time: '12-20', total: 4000, title: '客单价（元）', type: 2 },
    { time: '12-20', total: 5000, title: '新客用户数', type1: 1 },
    { time: '12-20', total: 6000, title: '新客支付金额（元）', type: 2 },
    { time: '12-20', total: 7000, title: '新客客单价（元）', type: 2 },

    { time: '12-21', total: 2000, title: '支付用户总数', type1: 1 },
    { time: '12-21', total: 3000, title: '支付总金额（元）', type: 2 },
    { time: '12-21', total: 5000, title: '客单价（元）', type: 2 },
    { time: '12-21', total: 6000, title: '新客用户数', type1: 1 },
    { time: '12-21', total: 1000, title1: '新客支付金额（元）', type: 2 },
    { time: '12-21', total: 4000, title1: '新客客单价（元）', type: 2 },

    { time: '12-22', total: 3000, title: '支付用户总数', type1: 1 },
    { time: '12-22', total: 5000, title: '支付总金额（元）', type: 2 },
    { time: '12-22', total: 9000, title: '客单价（元）', type: 2 },
    { time: '12-22', total: 5000, title: '新客用户数', type1: 1 },
    { time: '12-22', total: 6000, title: '新客支付金额（元）', type: 2 },
    { time: '12-22', total: 2000, title: '新客客单价（元）', type: 2 },

  ];
  // y 轴的比例
  const scale = {
    total: {
      min: 0,
      //  当数据之和为0的时候 才会赋最大值
      max: 2000,
    },
  };
  useEffect(() => {
    // 模拟调接口后处理标签数据
    // const newTagList = tagList.map(v => ({
    //   ...v,
    //   total: utils.numFormat(tagData.find(item => item.title === v.title)?.total || v.total)
    // }))
    // setTagList(newTagList);
    // 模拟调接口处理折线图数据
    // setLineChartData(data)
  }, []);
  // 选择tag
  useEffect(() => {
    const arr = [];
    // chooseTag.forEach(item => {
    //   lineChartData.forEach(val => {
    //     if (item === val.id) {
    //       arr.push(val)
    //     }
    //   })
    //   setChooseLinechartData(arr);
    // })
    lineChartData.forEach((val) => {
      if (chooseTag === val.analysisId) {
        val.time = moment(val.reportDate).format('YYYY-MM-DD');
        arr.push(val);
      }
      setChooseLinechartData(arr);
    });
  }, [chooseTag]);
  // 切换日期tab
  useEffect(() => {
    // console.log(currentKey)
    // setChooseLinechartData([]);
    // setChooseTag([]);
    // 请求 展示 标签接口    url: '/api/crowd/analysis/index',
    Servlets('getShopSurvey', { time: currentKey }).then((res) => {
      setTagList(res.data);
    });
    // 图表数据
    Servlets('getShopChart', { time: currentKey }).then((res) => {
      // console.log(res.data)
      // res.data.sort((a,b)=>{ return a.time-b.time});
      // res.data.sort((a,b)=>{ return a.id-b.id});
      // res.data.forEach(item => {
      //   item.time = moment(item.time).format('YYYY-MM-DD')
      //   item.title = chartTitle[item.id-1]
      // })
      // console.log(res.data)

      setLineChartData(res.data);
      const arr = [];
      if (chooseTag) {
        res.data.length < 1 ? res.data = [{
          analysisId: 1,
          time: moment().format('YYYY-MM-DD'),
          total: 0,
        },
        {
          analysisId: 2,
          time: moment().format('YYYY-MM-DD'),
          total: 0,
        },
        ] : '';
        res.data.forEach((item) => {
          if (Number(item.analysisId) === Number(chooseTag)) {
            item.time = moment(item.reportDate).format('YYYY-MM-DD');
            // 如果累和 为 0  则需要：scale
            let sum = 0;
            sum += Number(item.total);
            if (sum == 0) {
              setYAxisNeed(true);
            }
            arr.push(item);
          }
        });

        // }
        setChooseLinechartData(arr);
        // 图表数据是否大于一条   不大于一条 需要 scale
        arr.length > 1 ? '' : setYAxisNeed(true);
      } else {

      }
    });
  }, [currentKey]);
  return (
    <>
      <div className={styles.row_between}>
        <ParagraphTitle
          title="店铺概况"
          subtitle={`数据更新日期：${chooseLinechartData && chooseLinechartData[0] ? chooseLinechartData[0].time : ''}`}
        />
        <div style={{ width: 270 }}>
          <TimeTab
            activeKey={currentKey}
            list={trendList}
            onChange={(tabKey) => {
              setCurrentKey(tabKey);
            }}
          />
        </div>
      </div>
      <div className={styles.pageBox}>
        <div>
          <Tag.Group style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Tag.Selectable
              key={chartTitle[0]}
              checked={tagChooseStatu[0]}
              className={styles.tagSize}
              onChange={(v) => {
                const temp = [];
                temp.length = 6;
                temp.fill(false);
                temp[0] = true;
                setTagChooseStatu(temp);
                setChooseTag(1);
              }}
            >
              <div>
                <div className={styles.tagNUm}>{tagList.oldPayUsers.toLocaleString()}</div>
                <div className={styles.tagTitle}>{chartTitle[0]}</div>
              </div>
            </Tag.Selectable>
            <Tag.Selectable
              key={chartTitle[1]}
              checked={tagChooseStatu[1]}
              className={styles.tagSize}
              onChange={(v) => {
                const temp = [];
                temp.length = 6;
                temp.fill(false);
                temp[1] = true;
                setTagChooseStatu(temp);
                setChooseTag(2);
              }}
            >
              <div>
                <div className={styles.tagNUm}>{tagList.oldPayAmount.toLocaleString()}</div>
                <div className={styles.tagTitle}>{chartTitle[1]}</div>
              </div>
            </Tag.Selectable>
            <Tag.Selectable
              key={chartTitle[2]}
              checked={tagChooseStatu[2]}
              className={styles.tagSize}
              onChange={(v) => {
                const temp = [];
                temp.length = 6;
                temp.fill(false);
                temp[2] = true;
                setTagChooseStatu(temp);
                setChooseTag(3);
              }}
            >
              <div>
                <div className={styles.tagNUm}>{tagList.oldCustomerPrice.toLocaleString()}</div>
                <div className={styles.tagTitle}>{chartTitle[2]}</div>
              </div>
            </Tag.Selectable>
            <Tag.Selectable
              key={chartTitle[3]}
              checked={tagChooseStatu[3]}
              className={styles.tagSize}
              onChange={(v) => {
                const temp = [];
                temp.length = 6;
                temp.fill(false);
                temp[3] = true;
                setTagChooseStatu(temp);
                setChooseTag(4);
              }}
            >
              <div>
                <Tooltip
                  id="aria-tooltip"
                  align="t"
                  trigger={<div
                    style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      fontSize: '16px',
                      cursor: 'pointer',
                    }}
                    className={'iconfont icon-icon4-33'}
                  />}
                >
                  店铺首次购买客户
                </Tooltip>
                <div className={styles.tagNUm}>{tagList.newPayUsers.toLocaleString()}</div>
                <div className={styles.tagTitle}>{chartTitle[3]}</div>
              </div>
            </Tag.Selectable>
            <Tag.Selectable
              key={chartTitle[4]}
              checked={tagChooseStatu[4]}
              className={styles.tagSize}
              onChange={(v) => {
                const temp = [];
                temp.length = 6;
                temp.fill(false);
                temp[4] = true;
                setTagChooseStatu(temp);
                setChooseTag(5);
              }}
            >
              <div>
                <Tooltip
                  id="aria-tooltip"
                  align="t"
                  trigger={<div
                    style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      fontSize: '16px',
                      cursor: 'pointer',
                    }}
                    className={'iconfont icon-icon4-33'}
                  />}
                >
                  店铺首次购买金额
                </Tooltip>
                <div className={styles.tagNUm}>{tagList.newPayAmount.toLocaleString()}</div>
                <div className={styles.tagTitle}>{chartTitle[4]}</div>
              </div>
            </Tag.Selectable>
            <Tag.Selectable
              key={chartTitle[5]}
              checked={tagChooseStatu[5]}
              className={styles.tagSize}
              onChange={(v) => {
                const temp = [];
                temp.length = 6;
                temp.fill(false);
                temp[5] = true;
                setTagChooseStatu(temp);
                setChooseTag(6);
              }}
            >
              <div>
                <Tooltip
                  id="aria-tooltip"
                  align="t"
                  trigger={<div
                    style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      fontSize: '16px',
                      cursor: 'pointer',
                    }}
                    className={'iconfont icon-icon4-33'}
                  />}
                >
                  店铺首次购买总金额/店铺首次购买用户数
                </Tooltip>
                <div className={styles.tagNUm}>{tagList.newCustomerPrice.toLocaleString()}</div>
                <div className={styles.tagTitle}>{chartTitle[5]}</div>
              </div>
            </Tag.Selectable>


          </Tag.Group>
        </div>
        {/* 店铺概况  折线图 */}
        <section style={{ marginTop: 50, width: '100%' }}>
          <Chart
            padding={[30, 40, 50, 40]}
            autoFit
            height={375}
            data={chooseLinechartData}
            interactions={['element-active']}
            scale={yAxisNeed ? scale : false}
          >
            {/* <Point position="month*temperature" color="city" shape='circle' /> */}
            {/* color={['title', ['#ff0000', '#ffff00']]} */}
            {/* <Axis name="total" position="left" />
            <Axis name="total" position="right" />
            <Axis name="time" position="bottom" />  */}
            {/* <Geom type="line" position="time*total" color="analysisId" /> */}
            <LineAdvance shape="smooth" point area position="time*total" />
          </Chart>
        </section>
      </div>
    </>
  );
};

export default DYShopSurvey;
